/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useMemo } from 'react';
import { setMatchedRoute } from '@jira/platform__utils-router/src/common/utils/index.tsx';
import { useRouter } from '@atlassian/react-resource-router';

const MatchedRouteListener = (): null => {
	const [{ route, match }] = useRouter();
	useMemo(() => setMatchedRoute(route, match), [route, match]);
	return null;
};

export { MatchedRouteListener };
